import { useCallback, useEffect, useState } from 'react';
import { familyAPI } from '../../services/api';
import type { FamilyAgenda } from '../../types/family';

/** A családi nézet adatai egy időszakra; `reload` után frissül. */
export const useFamilyAgenda = (from: string, to: string) => {
  const [agenda, setAgenda] = useState<FamilyAgenda | null>(null);
  const [error, setError] = useState(false);

  const reload = useCallback(async () => {
    try {
      setAgenda(await familyAPI.getAgenda(from, to));
      setError(false);
    } catch (err) {
      console.error('A program betöltése nem sikerült:', err);
      setError(true);
    }
  }, [from, to]);

  // Új időszaknál a régi adat ne látszódjon (pl. "nincs program" villanás), amíg betölt
  useEffect(() => {
    setAgenda(null);
    reload();
  }, [reload]);

  return { agenda, setAgenda, error, reload };
};
